<template>
    <span :data-balloon="tooltip" data-balloon-pos="up">
        <i @click="open" class="fa fa-trash"></i>
        <div class="remodal" :data-remodal-id="modalID">
            <p>Are you sure you want to delete <strong>{{title}}</strong>? This action cannot be undone.</p>
            <button data-remodal-action="cancel" class="remodal-cancel simple">Cancel</button>
            <button data-remodal-action="confirm" class="remodal-confirm simple" @click="confirm">OK</button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal';
    import axios from 'axios';

    export default {
        computed: {
            modalID() {
                return `${this.id}-file-delete`
            },
        },

        methods: {
            confirm() {
                // Assign FormData element to a var to expand it's scope
                var formData = new FormData();

                formData.append("id", this.id);
                formData.append("design_id", this.designId);

                axios.get('/actions/seismic-submittal/file-upload/get-upload-token')
                    .then(function (response) {
                        // Set the CSRF token
                        formData.append("token", response.data);
                    })
                    .then(function(response) {
                        axios.post('/actions/seismic-submittal/file-upload/delete-file', formData)
                            .then(response => {
                                var data = response.data;

                                if (data.error) {
                                    //console.log(data.error);
                                } else {
                                    // Successful delete - reload page
                                    window.location.reload();
                                }
                            });
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },
        },
        extends: Modal,

        props: {
            id: {
                type: String
            },
            designId: {
                type: String
            },
            title: {
                type: String
            },
            url: {
                type: String
            },
            tooltip: {
                default: "Delete",
                type: String
            }
        }
    }
</script>